import type { SiteWixCodeSdkFactoryData, WixCodeApiFactoryArgs } from '@wix/thunderbolt-symbols'
import type {
	SsrCacheWixCodeSdkFactoryData,
	SsrCacheWixCodeSdkHandlers,
	SsrCacheWixCodeSdkWixCodeApi,
	SsrCacheVeloState,
	SsrCacheFactoryState,
} from './types'
import { namespace } from './types'

/**
 * SSR Cache SDK Factory
 */
export function SsrCacheSdkFactory({
	handlers,
	platformUtils: { sessionService },
	appDefinitionId: sdkInstanceAppDefinitionId,
}: WixCodeApiFactoryArgs<SiteWixCodeSdkFactoryData, SsrCacheWixCodeSdkFactoryData, SsrCacheWixCodeSdkHandlers>): Record<typeof namespace, SsrCacheWixCodeSdkWixCodeApi> {
	const { setCustomInvalidateTags } = handlers.ssrCache

	// Initialize state
	const initialState: SsrCacheVeloState = {
		customInvalidateTags: [],
	}

	const state: SsrCacheFactoryState = {
		state: {
			ssrCache: { ...initialState },
		},
		setSSRCacheState(partialState: Partial<SsrCacheVeloState>) {
			Object.assign(state.state.ssrCache, partialState)
		},
	}

	// Get the instanceId for the current app
	const instanceId = sessionService.getInstance(sdkInstanceAppDefinitionId)

	// Create security prefixing function
	const addSecurityPrefix = (tags: Array<string>): Array<string> => {
		return tags.map((tag) => `${sdkInstanceAppDefinitionId}_${instanceId}_${tag}`)
	}

	return {
		[namespace]: {
			get customInvalidateTags() {
				return state.state.ssrCache.customInvalidateTags
			},
			async setCustomInvalidateTags(customInvalidateTags: Array<string>) {
				const secureCustomInvalidateTags = addSecurityPrefix(customInvalidateTags)
				setCustomInvalidateTags(secureCustomInvalidateTags)
				state.setSSRCacheState({ customInvalidateTags: secureCustomInvalidateTags })
			},
		},
	}
}
